import Button, { ButtonProps } from '@jusbrasil-rc/button'

import { buttonColorMapping } from './button-color-mapping'
import styles from './flashtag.module.scss'

export interface FlashtagProps {
  title: string
  subtitle: string
  type?: 'info' | 'warning'
  iconClassName?: string
  buttonProps?: Partial<ButtonProps> & { label: string }
}

export function Flashtag({
  title,
  subtitle,
  type = 'info',
  iconClassName,
  buttonProps,
}: FlashtagProps) {
  return (
    <div className={`${styles.flashtag} ${styles[type]}`}>
      {iconClassName && (
        <i className={`icon flashtagIcon ${iconClassName}`} data-testid="flashtag-icon" />
      )}
      <div className={styles.flashtagContent}>
        <div>
          <h5 className={styles.flashtagContentTitle}>{title}</h5>
          <p
            className={styles.flashtagContentSubtitle}
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
        </div>
        {buttonProps?.label && (
          <Button
            className={styles.flashtagContentButton}
            {...buttonProps}
            isFlat
            color={buttonColorMapping[type]}
            data-testid="flashtag-button"
          >
            {buttonProps.label}
          </Button>
        )}
      </div>
    </div>
  )
}
